import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useBrand } from '../hooks/useBrand.jsx';

/**
 * Which brand this account is working as, for accounts running several, and
 * the way to add another. In the dashboard header and the site header alike,
 * so the brand can be changed while browsing too. A native select: keyboard
 * and screen-reader friendly, and it becomes the phone's own picker on mobile.
 */
export function BrandSwitcher({ className = '' }) {
  const { brands, activeBrandId, switchBrand } = useBrand();
  const navigate = useNavigate();
  const location = useLocation();
  const [busy, setBusy] = useState(false);

  if (!brands.length) return null;

  async function onChange(e) {
    const value = e.target.value;
    if (value === '__new') {
      navigate('/dashboard/brand/new');
      return;
    }
    setBusy(true);
    try {
      await switchBrand(value);
      // A single program belongs to the brand just left; go to the new one's list.
      if (/^\/dashboard\/brand\/programs\/[^/]+/.test(location.pathname)) {
        navigate('/dashboard/brand/programs');
      }
    } finally {
      setBusy(false);
    }
  }

  return (
    <label className={`flex min-w-0 items-center ${className}`}>
      <span className="sr-only">Brand</span>
      <select
        value={activeBrandId ?? ''}
        onChange={onChange}
        disabled={busy}
        className="max-w-48 truncate rounded-md border border-rule-strong bg-paper px-2 py-1 text-xs font-medium text-ink"
      >
        {brands.map((b) => (
          <option key={b.id} value={b.id}>
            {b.companyName}
            {b.isPublished ? '' : ' (draft)'}
          </option>
        ))}
        <option value="__new">+ Add a brand…</option>
      </select>
    </label>
  );
}
